import { isNil } from 'ramda';
import React, { useEffect, useMemo, useState } from 'react';
import { apiClient } from '~admin/client';
import { log } from '~common/service/logger';
import { initializePersistence } from '~admin/service/persistence';
import { AdminAuthStore } from '~admin/store/admin-auth-store';
import { useProvidedStore } from '~common/hook/use-provided-store';
import { StoreProvider, StoreProviderProps } from '~common/store/store-provider.component';

const adminAuthStoreContext = React.createContext<AdminAuthStore | null>(null);

export const AdminAuthStoreProvider: React.FunctionComponent<StoreProviderProps<
  AdminAuthStore
>> = ({ children, ...rest }) => {
  const store = useMemo(() => new AdminAuthStore(), []);
  const [persistenceInitialized, setPersistenceInitialized] = useState<boolean>(false);

  useEffect(() => {
    if (!isNil(store)) {
      initializePersistence({ adminAuthStore: store }, localStorage);

      const { authToken } = store;
      if (!isNil(authToken)) {
        log.info('Restored token.');
        apiClient.setAuthorization(authToken);
      }

      setPersistenceInitialized(true);
    }
  }, [store]);

  return (
    <StoreProvider store={store} context={adminAuthStoreContext} {...rest}>
      {persistenceInitialized && children}
    </StoreProvider>
  );
};

export const useAdminAuthStore = (): AdminAuthStore => {
  return useProvidedStore(adminAuthStoreContext, 'AdminAuthStore');
};



// WEBPACK FOOTER //
// ./store/admin-auth-store-provider.tsx